import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  FormControl,
  MenuItem,
  Select,
  InputLabel
} from "@mui/material";
import { post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

/* =========================
   Interface
========================= */
interface ThirdPartyAppPayload {
  //id: string;
  appName: string;
  appType: string;
  //createdDate: string;
  isActive: boolean;
}

const AddThirdPartyApp = ({ fetchApps,handleClose }) => {
  const { showSnackbar } = useSnackbar();
  const APIURL = process.env.REACT_APP_BASE_API_URL;

  const [formData, setFormData] = useState({
    appName: "",
    appType: "",
    isActive: true
  });

  const APP_TYPES = [
    { label: "Watcho", value: "WATCHO" },
    { label: "SonyLIV", value: "SONYLIV" },
    { label: "ZEE5", value: "ZEE5" },
    { label: "Sun NXT", value: "SUNNXT" },
    { label: "Disney+ Hotstar", value: "HOTSTAR" },
    { label: "Amazon Prime", value: "PRIME" }
  ];

  const [loading, setLoading] = useState(false);

  /* =========================
     Handlers
  ========================= */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, isActive: e.target.checked }));
  };

  const handleSubmit = async () => {
    if (!formData.appName || !formData.appType) {
      showSnackbar("All fields are required", "error");
      return;
    }

    const payload: ThirdPartyAppPayload = {
      //id: crypto.randomUUID(), // remove if backend generates ID
      appName: formData.appName,
      appType: formData.appType,
      //createdDate: new Date().toISOString(),
      isActive: formData.isActive
    };

    try {
      setLoading(true);

      await post(`${APIURL}/api/third-party-apps`, payload);
      fetchApps()
      showSnackbar("Third-party app created successfully", "success");
      
      setFormData({
        appName: "",
        appType: "",
        isActive: true
      });

      handleClose()
    } catch (error: any) {
      showSnackbar(
        error?.message || "Failed to create app",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500 }}>
      <TextField
        fullWidth
        label="App Name"
        name="appName"
        value={formData.appName}
        onChange={handleChange}
        margin="normal"
      />

      <FormControl fullWidth margin="normal">
        <InputLabel>App Type</InputLabel>

        <Select
          name="appType"
          value={formData.appType}
          label="App Type"
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              appType: e.target.value
            }))
          }
        >
          {APP_TYPES.map((app) => (
            <MenuItem key={app.value} value={app.value}>
              {app.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Switch
            checked={formData.isActive}
            onChange={handleToggle}
          />
        }
        label="Active"
      />

      <Box>
        <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? "Saving..." : "Create App"}
      </Button>
      </Box>
    </Box>
  );
};

export default AddThirdPartyApp;
